import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56fa4b71")

_pushScopeId("data-v-56fa4b71")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Dettaglio intervento")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "card_title" }
const _hoisted_5 = { class: "intervento" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Cliente ")
const _hoisted_7 = { class: "base_text" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ticket di riferimento ")
const _hoisted_9 = { class: "base_text" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Ora inizio e fine ")
const _hoisted_11 = { class: "base_text" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Tecnici")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_14 = /*#__PURE__*/_createVNode("h3", { class: "description_title" }, "Descrizione", -1)
const _hoisted_15 = { class: "base_text" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h3", { class: "description_title" }, "Materiali", -1)
const _hoisted_17 = { class: "base_text" }
const _hoisted_18 = { class: "immagini_container" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "field_title" }, [
  /*#__PURE__*/_createVNode("h3", { class: "description_title" }, "Foto caricate")
], -1)
const _hoisted_20 = {
  key: 0,
  class: "gallery_container"
}
const _hoisted_21 = {
  key: 1,
  class: "no_foto"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Nessuna foto caricata")
const _hoisted_23 = { class: "btn_foto ion-padding-horizontal" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Aggiungi foto ")
const _hoisted_25 = { class: "btn_actions ion-padding-horizontal" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Firma cliente ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Firma cliente ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Firma operatore ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Firma operatore ")
const _hoisted_30 = { class: "btn_action ion-padding-horizontal" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Invia email cliente ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Invia email cliente ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_card_title = _resolveComponent("ion-card-title")
  const _component_ion_card_header = _resolveComponent("ion-card-header")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "primary"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_ion_card, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_card_header, { class: "pb-0 bg-primary" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_text, { color: "light" }, {
                              default: _withId(() => [
                                _createVNode("p", _hoisted_4, " Intervento del " + _toDisplayString($setup.dateFormat($setup.intervento.tickets_reports_date)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, null, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_5, [
                          _createVNode(_component_ion_list, null, {
                            default: _withId(() => [
                              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { color: "primary" }, {
                                    default: _withId(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_text, null, {
                                    default: _withId(() => [
                                      _createVNode("p", _hoisted_7, _toDisplayString($setup.riferimentoCliente($setup.intervento)), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { color: "primary" }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_text, null, {
                                    default: _withId(() => [
                                      _createVNode("p", _hoisted_9, _toDisplayString($setup.checkField($setup.intervento.tickets_subject)), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { color: "primary" }, {
                                    default: _withId(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_text, null, {
                                    default: _withId(() => [
                                      _createVNode("p", _hoisted_11, _toDisplayString($setup.intervento.tickets_reports_start_time) + " - " + _toDisplayString($setup.intervento.tickets_reports_end_time), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { color: "primary" }, {
                                    default: _withId(() => [
                                      _hoisted_12
                                    ]),
                                    _: 1
                                  }),
                                  ($setup.intervento.tickets_reports_tecnici)
                                    ? (_openBlock(), _createBlock(_component_ion_text, { key: 0 }, {
                                        default: _withId(() => [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.intervento.tickets_reports_tecnici, (tecnico, index) => {
                                            return (_openBlock(), _createBlock("div", {
                                              style: {"text-align":"right"},
                                              key: index
                                            }, _toDisplayString(tecnico), 1))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_ion_text, { key: 1 }, {
                                        default: _withId(() => [
                                          _hoisted_13
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode("div", null, [
                                    _hoisted_14,
                                    _createVNode("p", _hoisted_15, _toDisplayString($setup.checkField($setup.intervento.tickets_reports_description)), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode("div", null, [
                                    _hoisted_16,
                                    _createVNode("p", _hoisted_17, _toDisplayString($setup.checkField($setup.intervento.tickets_reports_used_equipments)), 1)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_18, [
                                    _hoisted_19,
                                    ($setup.interventoImmagini.length != 0)
                                      ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.interventoImmagini, (img, index) => {
                                            return (_openBlock(), _createBlock("div", {
                                              key: index,
                                              class: "thumbnail"
                                            }, [
                                              _createVNode(_component_ion_thumbnail, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_ion_img, {
                                                    src: $setup.setImage(img)
                                                  }, null, 8, ["src"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]))
                                          }), 128))
                                        ]))
                                      : (_openBlock(), _createBlock("div", _hoisted_21, [
                                          _createVNode(_component_ion_text, { color: "danger" }, {
                                            default: _withId(() => [
                                              _hoisted_22
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_23, [
                  _createVNode(_component_ion_button, {
                    color: "primary",
                    size: "default",
                    expand: "block",
                    onClick: $setup.modalPhoto
                  }, {
                    default: _withId(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode("div", _hoisted_25, [
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "primary",
                    size: "default",
                    expand: "block",
                    onClick: $setup.firmaCliente
                  }, {
                    default: _withId(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, !$setup.customerNotSigned]
                  ]),
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "success",
                    size: "default",
                    expand: "block",
                    disabled: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_27,
                      _createVNode(_component_ion_icon, { icon: $setup.checkmark }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.customerNotSigned]
                  ]),
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "primary",
                    size: "default",
                    expand: "block",
                    onClick: $setup.firmaOperatore
                  }, {
                    default: _withId(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, !$setup.operatorNotSigned]
                  ]),
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "success",
                    size: "default",
                    expand: "block",
                    disabled: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_29,
                      _createVNode(_component_ion_icon, { icon: $setup.checkmark }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.operatorNotSigned]
                  ])
                ]),
                _createVNode("div", _hoisted_30, [
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "primary",
                    size: "default",
                    expand: "block",
                    onClick: $setup.sendMail
                  }, {
                    default: _withId(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, !$setup.sendCustomerMail]
                  ]),
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "success",
                    size: "default",
                    expand: "block",
                    disabled: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_32,
                      _createVNode(_component_ion_icon, { icon: $setup.checkmark }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.sendCustomerMail]
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})